module.exports = "/*\r\n    STYLE GUIDES\r\n*/\n.message {\n  color: #e32d54; }\n"